import config from '../envConfig/config';

export const getLoginFormClasses = () => {
  let formClasses = 'px-xl-5';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.form) {
    formClasses = config.REACT_APP_THEME.LoginLayoutClasses.form;
  }
  return formClasses;
};

export const getLoginButtonSubmitClasses = () => {
  let buttonClasses = 'form-control btn btn-global mt-3 text-uppercase btn-border-radius';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.buttonSubmit) {
    buttonClasses = config.REACT_APP_THEME.LoginLayoutClasses.buttonSubmit;
  }
  return buttonClasses;
};

export const getHomeWelcomeAlignClasses = () => {
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.homeWelcomeAlign) {
    return config.REACT_APP_THEME.LoginLayoutClasses.homeWelcomeAlign;
  }
  return '';
};

export const getWelcomeTextClasses = (config) => {
  let welcomeTextClass = 'responsive-border px-2 px-xl-5 py-2';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.welcomeText) {
    welcomeTextClass = config.REACT_APP_THEME.LoginLayoutClasses.welcomeText;
  }
  return welcomeTextClass;
};

export const getMfaButtonClasses = () => {
  let mfaButtonClasses = 'form-control btn btn-global mt-3 text-uppercase';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.buttonMfa) {
    mfaButtonClasses = config.REACT_APP_THEME.LoginLayoutClasses.buttonMfa;
  }
  return mfaButtonClasses;
};

export const getSignInButtonClasses = () => {
  let buttonsignInClasses = 'form-control btn btn-global mt-3 text-uppercase';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.buttonsignIn) {
    buttonsignInClasses = config.REACT_APP_THEME.LoginLayoutClasses.buttonsignIn;
  }
  return buttonsignInClasses;
};

export const getLoginGridColumnsRightClasses = () => {
  let gridColumnsRightClass = 'col-lg-4';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.gridColumnsRight) {
    gridColumnsRightClass = config.REACT_APP_THEME.LoginLayoutClasses.gridColumnsRight;
  }
  return gridColumnsRightClass;
};

export const getLoginGridColumnsLeftClasses = () => {
  let gridColumnsLeftClass = 'col-lg-8';
  if (config && config.REACT_APP_THEME && config.REACT_APP_THEME.LoginLayoutClasses && config.REACT_APP_THEME.LoginLayoutClasses.gridColumnsLeft) {
    gridColumnsLeftClass = config.REACT_APP_THEME.LoginLayoutClasses.gridColumnsLeft;
  }
  return gridColumnsLeftClass;
};

export const getSignUpButtonClasses = () => {
  const defaultClasses = {
    buttonCancel: 'btn btn-dark',
    buttonSave: 'btn btn-global',
  };

  const themeClasses = config && config.REACT_APP_THEME && config.REACT_APP_THEME.signUpClasses
    ? config.REACT_APP_THEME.signUpClasses
    : {};

  const buttonCancel = themeClasses.buttonCancel || defaultClasses.buttonCancel;
  const buttonSave = themeClasses.buttonSave || defaultClasses.buttonSave;

  return { buttonCancel, buttonSave };
};
